import Cookies from 'js-cookie';

export const getUserName = () => {
    const userData = Cookies.get('user');
    if (userData) {
        const user = JSON.parse(userData);
        return user.name;
    }
    return null;
};

/**
 * ISO -> local wall clock, '7:52pm'. Empty string when unparseable. The one
 * implementation: the guided flow and the Review tab must print a completion
 * at the same time down to the character.
 */
export const formatTime = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return '';
    // Newer ICU builds put a narrow no-break space before AM/PM, so strip any
    // whitespace, not just U+0020, or Chrome and Node print different strings.
    return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }).replace(/\s+/g, '').toLowerCase();
};

export const checkAllFieldsFilled = (args, inputFieldsConfig) => {
    return Object.keys(inputFieldsConfig).every(key => {
        const fieldConfig = inputFieldsConfig[key];
        const value = args[fieldConfig.apiKey];
        return value !== undefined && value !== null && value !== '';
    });
};

export const checkRequiredFieldsFilled = (args, inputFieldsConfig) => {
    return Object.values(inputFieldsConfig).every(fieldConfig => {
        if (fieldConfig.required) {
            const value = args[fieldConfig.apiKey];
            return value !== undefined && value !== null && value.toString().trim() !== '';
        }
        return true;
    });
};